import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { QuizProgressFacade } from '../facades/quiz-progress.facade';

export function quizProgressCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const progressFacade = inject(QuizProgressFacade);
        progressFacade.clear();

        return true;
    };
}
